import { EligibilityInfo } from "../types/eligibility";

// Move eligibility-related mock data here
export interface ProcedureCode {
  code: string;
  desc: string;
  cov: string;
}

export const mockEligibilityInfo: EligibilityInfo = {
  isEligible: true,
  plan: "Premium Dental PPO",
  network: "Preferred Network",
  group: "GRP-12345",
  deductible: "$50 Individual / $150 Family",
  remainingBenefit: "$1,500",
  codes: [
    { code: "D0120", desc: "Periodic Oral Exam", cov: "100%" },
    { code: "D0274", desc: "Bitewings - Four Films", cov: "100%" },
    { code: "D1110", desc: "Prophylaxis - Adult", cov: "100%" },
    { code: "D2391", desc: "Resin Filling - One Surface", cov: "80%" },
    { code: "D2392", desc: "Resin Filling - Two Surfaces", cov: "80%" },
    { code: "D3310", desc: "Root Canal - Anterior", cov: "50%" },
    { code: "D3320", desc: "Root Canal - Bicuspid", cov: "50%" },
  ],
};
